import DOMPurify from "dompurify";
import parse from "html-react-parser";

// CMS content (privacy policy, terms, etc.) is admin-editable rich text.
// We trust the admin but still defense-in-depth sanitize before parsing so a
// compromised admin account can't inject script tags into every visitor's page.
const sanitize = (html) =>
  typeof html === "string" && html.length > 0
    ? DOMPurify.sanitize(html, { USE_PROFILES: { html: true } })
    : "";

export const parseSafeHtml = (html) => {
  const clean = sanitize(html);
  return clean ? parse(clean) : null;
};

export default parseSafeHtml;
